<template>
  <div v-if="!isLoadingPage" class="fluid" id="auditList">
    <div v-if="permission != null">
      <div v-if="permission.read_perm == 1">
        <div class="audit-list-div">
          <v-card elevation="0" class="px-3 py-2" style="width: 100%">
            <v-row>
              <v-col
                cols="12"
                class="d-flex"
                style="
                  position: relative;
                  padding: 0 20px;
                  text-align: center;
                  margin-top: 20px;
                "
              >
                <h4
                  class="indigo--text"
                  style="font-weight: bold; margin: auto"
                >
                  LIST DOKUMEN AUDIT
                  <v-tooltip bottom color="grey">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        text
                        icon
                        color="grey darken-2"
                        @click="getDataFromApi"
                      >
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>refresh page</span>
                  </v-tooltip>
                </h4>
              </v-col>
              <v-col cols="12">
                <div>
                  <v-toolbar
                    class="group-list-toolbar-1"
                    flat
                    style="
                      height: 60px;
                      border-radius: 10px 10px 0 0;
                      padding-top: 15px;
                    "
                  >
                    <div class="d-flex align-content-start">
                      <div
                        style="margin-right: 15px; height: 45px"
                        class="d-flex justify-center align-center"
                      >
                        <v-btn
                          style="font-size: 12px"
                          @click="addDocument"
                          elevation="2"
                          tilerounded="5px"
                          color="primary"
                          class="white--text"
                          small
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small class="">
                                mdi-plus
                              </v-icon>
                            </template>
                            <span>Tambah Dokumen</span>
                          </v-tooltip>
                        </v-btn>
                      </div>
                    </div>
                    <div style="width: 210px; height: 45px">
                      <v-autocomplete
                        v-model="paramAPI.company_id"
                        label="Perusahaan"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="companyWatcher"
                        :items="dropdown.company"
                        :disabled="isDisableCompanyDropdown"
                      ></v-autocomplete>
                    </div>
                    <div style="width: 180px; height: 45px; margin-left: 15px">
                      <v-autocomplete
                        v-model="paramAPI.audit_type_id"
                        label="Audit Type"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="auditTypeWatcher"
                        :items="dropdown.auditType"
                      ></v-autocomplete>
                    </div>
                    <div style="width: 180px; height: 45px; margin-left: 15px">
                      <v-autocomplete
                        v-model="paramAPI.status"
                        label="Status"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="auditStatusWatcher"
                        :items="dropdown.status"
                      ></v-autocomplete>
                    </div>
                    <div
                      style="
                        height: 42px;
                        margin-top: 5px;
                        margin-bottom: 8px;
                        margin-left: 10px;
                      "
                      class="d-flex"
                    >
                      <v-text-field
                        class="ml-1 mr-2"
                        dense
                        label="Start"
                        type="date"
                        name="startdate"
                        style="height: 30px"
                        step="1"
                        v-model="paramAPI.start_date"
                        @change="startDateWatcher"
                        outlined
                        clearable
                      />

                      <v-text-field
                        class="ml-1 mr-2"
                        dense
                        label="End"
                        type="date"
                        name="enddate"
                        style="height: 30px"
                        step="1"
                        v-model="paramAPI.end_date"
                        @change="endDateWatcher"
                        outlined
                        clearable
                      />
                    </div>
                    <div
                      style="width: 30%; margin-left: auto; margin-top: 20px"
                    >
                      <v-text-field
                        v-model="paramAPI.keyword"
                        @keyup.enter="searchEnter"
                        label="Search here"
                        type="search"
                        append-icon="mdi-magnify"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </v-toolbar>
                </div>
              </v-col>

              <v-col cols="12" style="width: 100%">
                <v-data-table
                  v-if="result.length > 0 || !skeleton_loading"
                  mobile-breakpoint="0"
                  fixed-header
                  height="50vh"
                  :headers="headers"
                  style="cursor: pointer"
                  :items="result"
                  :loading="loading"
                  @click:row="rowClick"
                  item-key="id"
                  :options.sync="options"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                  }"
                  :server-items-length="totalData"
                  :page="paramAPI.page"
                  @update:page="updatePage"
                  :items-per-page="paramAPI.itemsPerPage"
                  @update:items-per-page="updateItemPerPage"
                >
                  <!-- <template v-slot:[`item.no`]="{ index }">
                  <div
                    style="
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                  </div>
                </template> -->
                  <template v-slot:[`item.audit_no`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        color: green;
                      "
                    >
                      {{ item.audit_no.toUpperCase() }}
                    </div>
                  </template>
                  <template v-slot:[`item.name`]="{ item }">
                    <div
                      style="
                        width: 140px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        color: green;
                      "
                    >
                      {{ item.name.toUpperCase() }}
                    </div>
                  </template>
                  <template v-slot:[`item.company_name`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.company_name }}
                    </div>
                  </template>
                  <!-- <template v-slot:[`item.department_name`]="{ item }">
                  <div
                    style="
                      width: 120px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ item.department_name }}
                  </div>
                </template> -->
                  <template v-slot:[`item.audit_type`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.audit_type != null ? item.audit_type.name : '' }}
                    </div>
                  </template>
                  <template v-slot:[`item.created_at`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ convertDate(item.created_at) }}
                    </div>
                  </template>
                  <template v-slot:[`item.updated_at`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ convertDate(item.updated_at) }}
                    </div>
                  </template>
                  <template v-slot:[`item.audit_date`]="{ item }">
                    <div
                      style="
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ convertDate(item.audit_date, 'date') }}
                    </div>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <div
                      :style="`color: ${colorStatus(
                        item.status
                      )}; font-size:12px; width: 70px; font-weight:bolder;`"
                    >
                      {{ item.status.name }}
                    </div>
                  </template>
                  <!-- <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }"
                        ><v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="rowClick(item)"
                          small
                          color="primary"
                          class="mr-2"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="error"
                          @click.stop="deleteItem(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </template> -->
                </v-data-table>
                <v-skeleton-loader
                  v-else
                  style="width: 100%"
                  type="table-heading, table-tbody, table-tfoot"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <v-dialog
          v-model="formAdd"
          persistent
          :fullscreen="dialogFullscreen"
          :max-width="500"
        >
          <v-card v-if="form !== null">
            <v-card-title>
              <p
                class="text-h5 text-center text-uppercase"
                style="margin: auto"
              >
                Tambah Dokumen
              </p>
            </v-card-title>
            <v-card-text>
              <v-form ref="entryForm2" @submit.prevent="saveForm">
                <v-container>
                  <v-row>
                    <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Nama Dokumen
                      </p>
                      <v-text-field
                        v-model="form.name"
                        :rules="rules.nameRules"
                        dense
                        outlined
                        style="height: 45px"
                      />
                    </v-col>
                    <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Perusahaan
                      </p>
                      <v-autocomplete
                        v-model="form.company"
                        :items="dropdown.company"
                        :rules="rules.companyRules"
                        item-text="name"
                        item-value="id"
                        return-object
                        dense
                        outlined
                        clearable
                        @change="formAuditTypeWatcher"
                        style="height: 45px"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Tipe Audit
                      </p>
                      <v-autocomplete
                        style="height: 45px"
                        v-model="form.audit_type_id"
                        :items="dropdown.auditType"
                        :rules="rules.auditTypeRules"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="formAuditTypeWatcher"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Tanggal Audit
                      </p>
                      <v-text-field
                        style="height: 45px"
                        v-model="form.audit_date"
                        :rules="rules.dateRules"
                        type="date"
                        name="date"
                        step="1"
                        dense
                        outlined
                      />
                    </v-col>
                    <v-col cols="12" class="d-flex flex-column">
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Template
                      </p>
                      <v-autocomplete
                        v-model="form.template_id"
                        :items="dropdown.template"
                        :rules="rules.templateRules"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        :disabled="
                          form == null ||
                          form.audit_type_id == null ||
                          form.company == null
                        "
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
                <v-btn
                  style="position: absolute; top: 10px; right: 10px"
                  fab
                  icon
                  x-small
                  outlined
                  @click="closeFormAdd"
                >
                  <v-icon size="30" color="red">mdi-close</v-icon>
                </v-btn>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    class="white--text"
                    type="submit"
                    style="width: 100%"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
                <v-divider v-if="form.act == 'update'"></v-divider>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <v-card
      v-else
      flat
      height="90vh"
      style="display: flex; justify-content: center; align-items: center"
    >
      <v-toolbar-title class="overline">
        You Can't Access This Page</v-toolbar-title
      >
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import buildType from '../../../services/buildType'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'masterauditType',
  data: () => ({
    editDialog: false,
    formAdd: false,
    formClause: false,
    dialogFullscreen: false,
    dssApi: buildType.apiURL('dss'),
    config: require('../../../services/config.json')[env],
    eSanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    isLoadingPage: true,
    permission: null,
    appLevel: null,
    userLevel: null,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      audit_type_id: null,
      status: null,
      start_date: null,
      end_date: null
      // department_id: null
    },
    totalData: 0,
    form: null,
    actionValue: 0,
    loading: false,
    isDisableCompanyDropdown: false,
    skeleton_loading: true,
    options: {},
    result: [],
    rules: {
      nameRules: [],
      companyRules: [],
      auditTypeRules: [],
      templateRules: []
    },
    dropdown: {
      company: [],
      auditType: [],
      department: [],
      status: [
        {
          name: 'Draft',
          id: 0
        },
        {
          name: 'Waiting Approval',
          id: 1
        },
        {
          name: 'In Progress',
          id: 2
        },
        {
          name: 'Done',
          id: 3
        },
        {
          name: 'Cancel',
          id: 4
        },
        {
          name: 'Reject',
          id: 5
        }
      ],
      template: []
    }
  }),

  async mounted() {
    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator

    // this.paramAPI.company_id = Number(
    //   this.getUserProfile.employee.company.plant_id
    // )
    // this.paramAPI.department_id = this.getUserProfile.employee.department_id
    // if (this.getShiftSettingPageQuery !== null) {
    //   this.paramAPI = this.getShiftSettingPageQuery
    // }
    this.getDataMenu()
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getAuditPageQuery']),
    headers() {
      const arrHeaders = [
        // {
        //   text: 'No',
        //   value: 'no',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'No. Dokumen',
          value: 'audit_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama Dokumen',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Perusahaan',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jenis Audit',
          value: 'audit_type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl Audit',
          value: 'audit_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'CreatedAt',
          value: 'created_at',
          align: 'left',
          sortable: false
        },
        {
          text: 'UpdatedAt',
          value: 'updated_at',
          align: 'left',
          sortable: false
        }
        // {
        //   text: 'Actions',
        //   value: 'action',
        //   align: 'left',
        //   sortable: false
        // }
      ]
      return arrHeaders
    }
  },
  watch: {},
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations(['setAuditPageQuery']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },

    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    initDataForLayout() {
      if (this.userLevel.user_user_level.allowed_company !== null) {
        if (
          this.userLevel.user_user_level.allowed_company.find(
            ({ id }) => id == this.getUserProfile.employee.company.plant_id
          ) !== undefined
        ) {
          this.paramAPI.company_id = Number(
            this.getUserProfile.employee.company.plant_id
          )
        } else {
          this.paramAPI.company_id = Number(
            this.userLevel.user_user_level.allowed_company[0].id
          )
        }
      } else {
        this.paramAPI.company_id = Number(
          this.getUserProfile.employee.company.plant_id
        )
      }
      if (this.getAuditPageQuery != null) {
        this.paramAPI = this.getAuditPageQuery
      }
      setTimeout(async () => {
        await this.getDataFromApi()
        await this.initDropdown()
      }, 200)
    },
    async initDropdown() {
      this.dropdownCompany()
      this.dropdownAuditType()
      // this.dropdownDepartment()
    },
    resetSomeParam() {
      this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.offset = 0
      this.paramAPI.page = 1
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    companyWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    auditStatusWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    auditTypeWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    startDateWatcher() {
      if (this.paramAPI.start_date && this.paramAPI.end_date) {
        this.resetSomeParam()
        this.getDataFromApi()
      } else if (!this.paramAPI.start_date && !this.paramAPI.end_date) {
        this.resetSomeParam()
        this.getDataFromApi()
      }
    },
    endDateWatcher() {
      if (this.paramAPI.start_date && this.paramAPI.end_date) {
        this.resetSomeParam()
        this.getDataFromApi()
      } else if (!this.paramAPI.start_date && !this.paramAPI.end_date) {
        this.resetSomeParam()
        this.getDataFromApi()
      }
    },
    formAuditTypeWatcher(val) {
      if (
        this.form != null &&
        this.form.audit_type_id != null &&
        this.form.company != null
      ) {
        this.dropdownFormTemplate()
      } else {
        this.dropdown.template = []
      }
    },

    async dropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) =>
          id == this.appLevel.administrator || id == this.appLevel.adminAudit
      )
      let xFlag = false
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            xFlag = true
          } else {
            this.dropdown.company = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          xFlag = true
        }
      } else {
        xFlag = true
      }

      if (xFlag) {
        // if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        //   this.isDisableCompanyDropdown = true
        // } else {
        //   this.isDisableCompanyDropdown = false
        // }
        axios
          .get(`${this.eSanqua}master/universal/plant/dropdown`)
          .then((res) => {
            this.dropdown.company = res.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },

    async dropdownAuditType() {
      await axios
        .get(`${this.dssApi}master/universal/audittype/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.auditType = res.data.data)
          }
          return (this.dropdown.auditType = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.auditType = [])
        })
    },

    async dropdownFormTemplate() {
      let url = `${this.dssApi}master/universal/formtemplate/dropdown`
      const filter = []
      if (this.form != null && this.form.company != null) {
        filter.push(`{"company_id": ${this.form.company.id}}`)
      }
      if (this.form != null && this.form.audit_type_id != null) {
        filter.push(`{"audit_type_id": ${this.form.audit_type_id}}`)
      }
      url = url + `?filter=[${filter}]`
      await axios
        .get(url)
        .then((res) => {
          console.log('dropdownFormTemplate>>>>>', res)
          if (res.data.status_code === '00') {
            return (this.dropdown.template = res.data.data)
          }
          return (this.dropdown.template = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.template = [])
        })
    },

    async getDataFromApi() {
      this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = data.total_record
            return (this.result = data.data)
          }
          return (this.result = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },
    async initDataTable() {
      let url = `${this.dssApi}audit/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }`
      // const filter = []
      if (this.paramAPI.company_id !== null) {
        // filter.push(`{"company_id": ${this.paramAPI.company_id}}`)
        url = url + `&company_id=${this.paramAPI.company_id}`
      }
      if (this.paramAPI.status !== null) {
        // filter.push(`{"status": ${this.paramAPI.status}}`)
        url = url + `&status=${this.paramAPI.status}`
      }
      if (this.paramAPI.audit_type_id !== null) {
        // filter.push(`{"audit_type_id": ${this.paramAPI.audit_type_id}}`)
        url = url + `&audit_type_id=${this.paramAPI.audit_type_id}`
      }

      if (this.paramAPI.start_date && this.paramAPI.end_date) {
        url = url + `&start_date=${this.paramAPI.start_date}`
        url = url + `&end_date=${this.paramAPI.end_date}`
      }

      // if (this.paramAPI.end_date) {
      //   url = url + `&end_date=${this.paramAPI.end_date}`
      // }

      // url = url + `&filter=[${filter}]`
      this.setAuditPageQuery(this.paramAPI)
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    rowClick(pItem) {
      setTimeout(() => {
        this.$router.push(`detail/${pItem.id}`)
      }, 100)
    },
    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          await axios
            .delete(`${this.dssApi}audit/delete/${pItem.id}`)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    // closeDialog() {
    //   this.form = null
    //   setTimeout(() => {
    //     this.editDialog = false
    //   }, 300)
    // },
    addDocument() {
      this.form = {
        act: 'add',
        name: null,
        company: null,
        // department: null,
        audit_type_id: null,
        audit_date: null,
        template_id: null
      }
      setTimeout(() => {
        this.dropdownFormTemplate()
        this.formAdd = !this.formAdd
      }, 300)
    },
    saveForm() {
      this.rules.nameRules = [(v) => !!v || 'Name is required']
      this.rules.companyRules = [(v) => !!v || 'Company is required']
      this.rules.auditTypeRules = [(v) => !!v || 'Audit Type is required']
      this.rules.dateRules = [(v) => !!v || 'Audit Date is required']
      this.rules.templateRules = [(v) => !!v || 'Template is required']

      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm2.validate()) {
          const form = {
            act: self.form.act,
            name: self.form.name,
            company_id: self.form.company.id,
            company_name: self.form.company.name,
            audit_type_id: self.form.audit_type_id,
            audit_date: self.form.audit_date,
            template_id: self.form.template_id
          }

          // if (self.form.department != null) {
          //   Object.assign(form, {
          //     department_id: self.form.department.id,
          //     department_name: self.form.department.name
          //   })
          // }

          if (form.act === 'update') {
            Object.assign(form, { id: self.form.id })
          }

          self.submitAuditDocument(form)
        }
      })
    },
    async submitAuditDocument(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}audit/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            // this.getDataFromApi()
            this.closeFormAdd()

            setTimeout(() => {
              this.$router.push(`detail/${res.data.created_id}`)
            }, 500)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeFormAdd() {
      this.formAdd = false
      setTimeout(() => {
        this.form = null
        this.dialogFullscreen = false
      }, 300)
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw, mode) {
      if (raw !== null) {
        const date = new Date(raw)
        let local = null
        if (mode && mode == 'date') {
          local = date.toLocaleDateString('id')
        }
        if (!mode) {
          local = date.toLocaleString('id')
        }

        return local
      } else {
        return '-'
      }
    },

    colorStatus(val) {
      switch (val.id) {
        case -1:
          return 'red'
        case 0:
          return '#1976d2'
        case 1:
          return 'orange'
        case 2:
          return 'green'
        case 3:
          return '#4CAF50'
        case 4:
          return 'red'
        case 5:
          return 'orange'
        // return '#1976d2'
      }
    }
  }
}
</script>
<style lang="scss">
#auditList {
  position: relative;
  .audit-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .audit-list-toolbar2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #auditList {
    .audit-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .audit-list-toolbar2 {
        display: block;
      }
    }
  }
}
</style>
